import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getUserActivePaymentMethod } from 'store/auth';

import { BoxLink } from 'components/Common';

import IconCreditCard from 'assets/images/icon-credit-card.svg';
import IconMobilePay from 'assets/images/icon-mobile-pay.svg';

export const SelectPaymentMethod = ({ t, activePaymentMethod }) => (
  <div className="row">
    <div className="column small-12 large-8">
      <h2>{t('paymentMethod.selection.heading')}</h2>

      <p>{t('paymentMethod.selection.description')}</p>

      <BoxLink.Container>
        <BoxLink
          image={IconCreditCard}
          title={t('paymentMethod.selection.paymentMethods.paymentCard.title')}
          description={
            activePaymentMethod &&
            t(
              'paymentMethod.selection.paymentMethods.paymentCard.description',
              {
                last4: activePaymentMethod.last4
              }
            )
          }
          to="/payment-method/update/payment-card"
        />
        <BoxLink
          image={IconMobilePay}
          title={t('paymentMethod.selection.paymentMethods.mobilePay.title')}
          to="/payment-method/update/payment-card"
        />
      </BoxLink.Container>

      <Link className="link-nav" to="/payment-method">
        &larr; {t('general.back')}
      </Link>
    </div>
  </div>
);

SelectPaymentMethod.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  activePaymentMethod: PropTypes.object
};

SelectPaymentMethod.defaultProps = {
  activePaymentMethod: null
};

const mapStateToProps = state => ({
  activePaymentMethod: getUserActivePaymentMethod(state)
});

export default connect(mapStateToProps)(translate()(SelectPaymentMethod));



// WEBPACK FOOTER //
// ./src/containers/SelectPaymentMethod/SelectPaymentMethod.js